module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"send":"Send","contact":{"subtitle":"Knows all"}},"nl":{"send":"Versturen","contact":{"subtitle":"kan je er alles over vertellen"}}}')
  delete Component.options._Ctor
}
